// extracted by mini-css-extract-plugin
export default {"select_seller_wrapper":"styles_select_seller_wrapper__tC0Ic","select_seller":"styles_select_seller__IzEQs"};